import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../shared/models/jobTypeCourt.model';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';
import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';
import { JobTypeAffidavit } from '../../../shared/models/jobTypeAffidavit.model';

import { JobServiceTimeframe } from '../../../shared/models/jobServiceTimeframe.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { VariableCodeBlock } from 'src/app/shared/models/variableCodeBlockModel.model';




import { query } from '@angular/animations';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { TemplateRef, ViewChild,  ViewEncapsulation } from '@angular/core';

import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { FilterSettingsModel, IFilter, ToolbarItems, GridComponent, GroupSettingsModel, IFilterUI, RowDataBoundEventArgs, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, DataUtil, Predicate, Query } from '@syncfusion/ej2-data';

// import { WoocommerceOrderService, WoocommerceProductsService } from 'ngx-wooapi';
import { concatMap, from } from 'rxjs';


import { MysqlService } from 'src/app/services/mysql.service';
//checkbox selection options
import { SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ppsDistrHubActionList } from './../../../shared/models/ppsDistroHubActionList.model';

import { FileUploadsModalComponent } from 'src/app/manager/file-uploads-modal/file-uploads-modal.component'; 
import html2canvas from 'html2canvas';
import { ppsDistrHubPromotion } from 'src/app/shared/models/ppsDistroHubPromotion.model';
// import { WordpressService } from 'src/app/services/wordpress.service';
import { InsertHtml, QuickToolbarSettingsModel, RichTextEditorComponent, ToolbarService, LinkService, ImageService, HtmlEditorService, EditorManager, FileManagerService, TableService } from '@syncfusion/ej2-angular-richtexteditor';

import { Form, FormsModule, Validators } from '@angular/forms';

// import{CodeMirror} from '@ctrl/ngx-codemirror'

// Now Code View COmponent
import * as CodeMirror from 'codemirror';
import { DomSanitizer } from 'node_modules/@angular/platform-browser';
import { DropDownList, DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { UploadEmailTemplateModalComponent } from '../../communication-manager/upload-email-template-modal/upload-email-template-modal.component';
import { UploadDotTemplateModalComponent } from '../../communication-manager/upload-dot-template-modal/upload-dot-template-modal.component';
import { UploadDocxTemplateModalComponent } from '../../communication-manager/upload-docx-template-modal/upload-docx-template-modal.component';
import { WooPromotionVariableModalComponent } from '../../system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { User } from 'src/app/models/user.model';
import { DateFormat } from 'node_modules/@syncfusion/ej2-base/intl';
import { Project } from 'src/app/shared/models/project';
import { TabsetComponent } from 'ngx-bootstrap';
// import { WooPromotionVariableModalComponent } from '../woo-promotion-variable-modal/woo-promotion-variable-modal.component';

@Component({
  selector: 'app-app-route-update-widget',
  templateUrl: './app-route-update-widget.component.html',
  styleUrls: ['./app-route-update-widget.component.scss'],
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService,],
})
export class AppRouteUpdateWidgetComponent implements OnInit {

  @ViewChild('brandForm') brandForm: NgForm; // the name of the form to access.
  // @Input('brandForm') brandForm: any;



  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
// grid other module
// grid other module
@Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;

  @Input() promotion_id: number;
  @Input() current_route: any;

model: AppRoute; 
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_court: any;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();


  job_service_rule: any;
  job_service_timeframe_count_types: any;
  job_service_timeframe_time_types: any;
  job_service_timeframe_time_when: any;
  job_service_timeframe_date_types: any;
  job_service_timeframe: any;
  brand_id: any;
  @Input() variable_code_block_id?: number;
  variable_code_block: any;
  variable_code_job_types: any;
  variable_code_block_insert_types: any;
  system_log_type_data_sectors: any;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  
  get_name: any;
  baseUploadURLOriginalWordTemplates: string;

         // toggle elements
        //  isShow = true;
        isShow_chart1 = false;
        isShow_chart2 = false;

        isShow_chart1_meta = false;
        isShow_chart2_meta = false; // user investigation as default
        isShow_chart3_meta = false; // user investigation as default
        // log view variables.
        isShow_created_by = false;
        isShow_data = false;
        isShow_data_tools = false;
        isShow_help_content = true;
        isShow_all_items = false;


        isShow_route_diagram = false;
        isShow_route_tree = false;
        isShow_route_grid = false;
        isShow_route_tree_map = false;
        isShow_route_tree_list = false;
        isShow_route_diagram_hierarchial = false;
        isShow_route_diagram_hierarchial_complex = false;
        isShow_route_diagram_local_data = false;
        isShow_route_diagram_on_init = false;
        isShow_route_diagram_users = false;
        isShow_route_diagram_over_view = false;
        isShow_route_diagram_radial_tree = false;
        isShow_route_diagram_app_network = false;
        isShow_route_diagram_kan_ban = false;
        isShow_route_diagram_kan_ban_children = true;
        isShow_route_diagram_kan_pan_data = true;
        isShow_route_diagram_proposal = false;
        isShow_route_diagram_hierarchial_children = false;


  // Text editor
  public myValue = 0;
  baseUploadURLDocxThemeTemplates: string;

  public insertImageSettings = {
    display: 'inline'
};

public mode: string = 'Markdown'; // Sets and removes for safe HTML/Sanitise etc  HTML | Markdown

@ViewChild('defaultRTE', {static: false}) defaultRTE;
@ViewChild('ejDialog', {static: false}) defaultDialog;
@ViewChild('ddlelement2', {static: false}) 
public countryObj: DropDownListComponent; 
public dropDownListObject: DropDownList
public editorManager: EditorManager; 
public proxy:any
public isParentDropdownChanged: boolean = false;
public rteObj: RichTextEditorComponent;

public dropdownVariables: DropDownList
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
public countryFields: Object = { text: 'CountryName', value: 'CountryId' };

initialPage: { pageSize: number; };
woo_products_object: any;
  doc_id: any;

  subject_template_doc: any;
  brand: any;
  placeHolderdata: string[] | DataManager | number[] | { [key: string]: Object; }[] | boolean[];
  dropdownVariablesOrderPickList: DropDownList;
  dropdownVariablesOrderSender: DropDownList;
  dropdownVariablesOrder: DropDownList;
  app_route: any;
  @Input() app_route_id: any;
  app_route_types: any;
  app_route_insert_types: any;
  app_routes: any;

  search_model: AppRoute;

  public cValue: string = "#1de4d7";
  app_routes_with_children: Object;
  user_levels: any;
  brand_types: any;
  formatOptions: { type: string; format: string; };
  dateFormat: DateFormat;
  filter: { params: { format: any; }; };
  pageOptions: { pageSize: number; };
  users: any;
  usersPrimary: any;
  get_latest_app_route_id: Object;
  projects: any;
  projects_data: Project;
  app_route_billing_items: any;
  app_route_gst: any;
  app_route_total: any;
  app_route_time_estimate: any;
  app_route_subtotal: number;
  app_routes_metrix_search_full: Object;
  app_routes_metrix_search_full_results: any;
  new_data: any;
  new_children_data: any;
  @Input('value')
  set value(value: any) {
      this.cValue = value;
  }
  public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
  public data_sector_fields: Object = { text: 'log_type_data_sector_name', value: 'log_type_data_sector_id', icon: 'log_type_data_sector_icon', colour: 'log_type_data_sector_colour', is_active: 'is_active', description: 'log_type_data_sector_description'}; // using the name field not id!



  isShow_condition_array = false;
  isShow_condition_array_example = false;
  isShow_condition_array_keys_example = false;
  isShow_condition_array_fields = false;
  isShow_database = false;
  isShow_database_model_angular = false;
  isShow_database_mysql = false;


  public opened() {
    this.defaultRTE.refreshUI();
  }
  
  // base product sample model based on Order ID 19348
  
  
  // my custom drop downs
  public height: any = '350px';
  
  
  public tools: object = {
    type: 'MultiRow',
        items: [ 
          'CreateTable',  '|' ,
          // {
          //   tooltipText: "PlaceHolder DropDown",        
          //   template:
          //     '<table><tr><td><input type="text" tabindex="1" id="ddlelement" /></td></tr></table>'
          // },
           '|',
        //   {
        //     tooltipText: 'Insert My Brand Variables',
        //     template: '<input type="text" id="dropdownVariables"/>'
        // },
        {
          tooltipText: 'Order Variables',
          template: '<input type="text" id="dropdownVariablesOrder" />'
      },
      {
        tooltipText: 'Order Sender',
        template: '<input type="text" id="dropdownVariablesOrderSender" />'
    },
      {
        tooltipText: 'Pick List Items',
        template: '<input type="text" id="dropdownVariablesOrderPickList" />'
    },
       '|',
      // {
      //   tooltipText: 'Insert/Upload Image',
      //   undo: true,
      //   click: this.onClickImageButton.bind(this),
      //   template: '<button type="button" class="btn btn-default"><i class="fa fa-photo"></i></button>'
      // },
      {
        tooltipText: 'Insert Promotion',
        undo: true,
        click: this.onClickPromotionButton.bind(this),
        template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
      },
       '|',      
    'Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat',
    'SourceCode', 'FullScreen', '|', 'Undo', 'Redo', '|', 
  
    ]
    };
  
  

  // Repalce
  public quickToolbarSettings: QuickToolbarSettingsModel = {
    image: [
         'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
        'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'
    ],
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
};

public size = {
    width: '40px',
    items: [{ text: '8', value: '8pt' },
    { text: '10', value: '10pt' },
    { text: '12', value: '12pt' },
    { text: '14', value: '14pt' },
    { text: '42', value: '42pt' }]
};
public family = {
    width: '60px',
    items: [
    { text: 'Segoe UI', value: 'Segoe UI' },
    { text: 'Arial', value: 'Arial,Helvetica,sans-serif' },
    { text: 'Courier New', value: 'Courier New,Courier,monospace' },
    { text: 'Georgia', value: 'Georgia,serif' },
    { text: 'Impact', value: 'Impact,Charcoal,sans-serif' },
    { text: 'Calibri Light', value: 'CalibriLight' }]
};

public dataVariables: { [key: string]: Object }[] = [
  // { Id: '2', Name: 'FirstName' },
  // { Id: '2', Name: 'LastName' },
  // { Id: '3', Name: 'MiddleName' }

// :: Owner mergeOwnerData
{ Id: '', Category: 'Owner', Name: 'Owner Business Name', insertValue: '${owner_business_name}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Phone', insertValue: '${owner_phone}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Address 1', insertValue: '${owner_address_1}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Address 2', insertValue: '${owner_address_2}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Suburb', insertValue: '${owner_suburb}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner State', insertValue: '${owner_state}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Postcode', insertValue: '${owner_postcode}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Country', insertValue: '${owner_country}', description: '' },
{ Id: '', Category: 'Owner', Name: 'Owner Type', insertValue: '${owner_brand_type_id}', description: '' },
];


public dataVariablesOrder: { [key: string]: Object }[] = [
// :: WordPress Order mergeOwnerData
{ Id: '', Category: 'Order', Name: 'OrderID', insertValue: '${order_id}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Company Output', insertValue: '${order_shipping_company_output}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Company', insertValue: '${order_shipping_company}', description: '' },
{ Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
{ Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
{ Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },

{ Id: '', Category: 'Order', Name: 'Address Line 1', insertValue: '${order_shipping_address_1}', description: '' },
{ Id: '', Category: 'Order', Name: 'Address Line 2', insertValue: '${order_shipping_address_2}', description: '' },
{ Id: '', Category: 'Order', Name: 'City', insertValue: '${order_shipping_city}', description: '' },
{ Id: '', Category: 'Order', Name: 'State', insertValue: '${order_shipping_state}', description: '' },
{ Id: '', Category: 'Order', Name: 'Postcode', insertValue: '${order_shipping_postcode}', description: '' },
{ Id: '', Category: 'Order', Name: 'Country Abrv.', insertValue: '${order_shipping_country}', description: '' },



{ Id: '', Category: 'Order', Name: 'Shipping Method', insertValue: '${shipping_data_method_title}', description: '' },
{ Id: '', Category: 'Order', Name: 'Shipping Total', insertValue: '${shipping_data_total}', description: '' },

{ Id: '', Category: 'Order', Name: 'Customm Postage Output', insertValue: '${owner_brand_type_id}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Items Table', insertValue: '${items}', description: '' },
{ Id: '', Category: 'Order', Name: 'Order Items Table Alternative', insertValue: '${items2}', description: '' },

{ Id: '', Category: 'Order', Name: 'Item Full - CodeOutPut', insertValue: '${item_full}', description: '' },
{ Id: '', Category: 'Order', Name: 'CurrentID', insertValue: '${id}', description: '' },

];



public dataVariablesOrderSender: { [key: string]: Object }[] = [
  // :: WordPress Order mergeOwnerData
  { Id: '', Category: 'Order', Name: 'Order From Company Output', insertValue: '${order_from_shipping_company_output}', description: '' },
  { Id: '', Category: 'Order', Name: 'Order From Company', insertValue: '${order_from_shipping_company}', description: '' },
  // { Id: '', Category: 'Order', Name: 'First Name Abrv.', insertValue: '${order_shipping_first_name_abr}', description: '' },
  // { Id: '', Category: 'Order', Name: 'First Name', insertValue: '${order_shipping_first_name}', description: '' },
  // { Id: '', Category: 'Order', Name: 'Surname', insertValue: '${order_shipping_first_name}', description: '' },
  
  { Id: '', Category: 'Order', Name: 'From Address Line 1', insertValue: '${order_from_shipping_address_1}', description: '' },
  { Id: '', Category: 'Order', Name: 'From Address Line 2', insertValue: '${order_from_shipping_address_2}', description: '' },
  { Id: '', Category: 'Order', Name: 'From City', insertValue: '${order_from_shipping_city}', description: '' },
  { Id: '', Category: 'Order', Name: 'From State', insertValue: '${order_from_shipping_state}', description: '' },
  { Id: '', Category: 'Order', Name: 'From Postcode', insertValue: '${order_from_shipping_postcode}', description: '' },
  { Id: '', Category: 'Order', Name: 'From Country Abrv.', insertValue: '${order_from_shipping_country}', description: '' },
  
  
  ];


  public dataVariablesOrderPickList: { [key: string]: Object }[] = [
    // :: WordPress Order mergeOwnerData
    { Id: '', Category: 'Order', Name: 'Pick List Title', insertValue: '${pick_list_title}', description: '' },
    { Id: '', Category: 'Order', Name: 'Today', insertValue: '${now_today}', description: '' },
    
    { Id: '', Category: 'Order', Name: 'Created - TimeStamp Words', insertValue: '${now_full_words}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Table Header', insertValue: '${pick_list_items_header}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Items (All) Table', insertValue: '${pick_list_items}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Items (Ebay) Table', insertValue: '${pick_list_ebay_items}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Items (WooCheckout) Table', insertValue: '${pick_list_checkout_items}', description: '' },
    { Id: '', Category: 'Order', Name: 'Pick List Key - Definition', insertValue: '${pick_list_key}', description: '' },

    ];



// Text editor Settings
public simpleToolBar: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo',
  // {
  //   tooltipText: 'Insert Promotion',
  //   undo: true,
  //   click: this.onClickPromotionButton.bind(this),
  //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
  // }
],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public pasteCleanupSettings: object = {
    prompt: true,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
};  


  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService,
    // private productService: WoocommerceProductsService,
    // private orderService: WoocommerceOrderService,
    public datepipe: DatePipe,
    private _mysqlService: MysqlService,
     private sanitizer: DomSanitizer 

  ) { 

    this.brand_id = this.gfunc.sessionBrandId;
    this.variable_code_block_id = +this.route.snapshot.paramMap.get('variable_code_block_id');
    this.app_route_id = +this.route.snapshot.paramMap.get('app_route_id');

  }


  ngOnChanges() {

    this.model = new AppRoute();
    this.getAppRoute(this.app_route_id);
    this.getAppRouteTypes()
    this.getAppRouteInsertTypes();
    this.getAppRoutes();
    this.getSystemLogTypeDataSectors();
    // this.getVariableCodeBlock(this.variable_code_block_id);
     this.getJobTypes();
     this.getFormUserLevels();
     this.getBrandTypes();
     this.getUsers();

     this.getAppRouteBillingItems(this.app_route_id);
     this.showLoadKanPanChildren()
   
    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);
//   this.model = new JobServiceTimeframe();
//  this.model = this.getJobServiceTimeframe(this.count);
//   this.getJobTypes();

//       // get the rules sql
//       this.getJobServiceTimeframeCountTypes();
//       this.getJobServiceTimeframeTimeTypes();
//       this.getJobServiceTimeframeTimeWhen();
//       this.getJobServiceTimeframeDateTypes();


  }

  ngOnInit() {


    this.model = new AppRoute();
    this.getAppRoute(this.app_route_id);
    this.getAppRouteTypes()
    this.getAppRouteInsertTypes();
    this.getAppRoutes();
    this.getAppRoutesWithChildItems();
    this.getAppRouteBillingItems(this.app_route_id);

    // this.getVariableCodeBlockInsertTypes();
    // this.getVariableCodeBlockTypes();
     this.getJobTypes();
     this.getSystemLogTypeDataSectors();
     this.getFormUserLevels();
     this.getUsers();
     this.getBrandTypes();
     this.showLoadKanPanChildren()

this.projects_data = new Project();
this.getProjects();

         // get the rules sql
        //  this.getJobServiceTimeframeCountTypes();
        //  this.getJobServiceTimeframeTimeTypes();
        //  this.getJobServiceTimeframeTimeWhen();
       //  this.getJobServiceTimeframeDateTypes();
  
       
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
  this.formatOptions= {type:'date', format:'dd/MM/yyyy' };
  this.dateFormat = 'dd/MM/yyyy hh:mm a';
  this.filter = { params: { format: this.dateFormat } };
 this.pageOptions = { pageSize: 100 }; 

  }





  getJobServiceRule(job_service_rule_id) {
    this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
       data => { this.job_service_rule = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getAppRouteBillingItems(app_route_id) {
    this._demoService.getAppRouteBillingItems(app_route_id).subscribe(
      data => { this.app_route_billing_items = data;
       let res = data[0];
       // Run the job data queries.

        // do some calculations 
      this.doCalculations_AppRouteBillingItems(this.app_route_billing_items );


     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  doCalculations_AppRouteBillingItems(app_route_billing_items){

    //  this.invoice_model = this.invoiceItem;
    
      // this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates !!!!!! NUMBER FORMAT MISSING>>>>>
                      // this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
                      // this.invoice_model.invoice_gst = this.invoice_tax;
                    
                      // // this.toastr.info('Calculating...');
                      // // this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
                      // this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += Number(b.total), 0);
                      // this.invoice_model.invoice_total = this.invoice_total + this.invoice_tax;
                      
                      // // this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
                      // // this.invoice_model.invoice_total = this.invoice_total += this.invoice_tax;
                    
                      // this.invoice_subtotal = (this.invoice_total - this.invoice_tax); // 
                      // this.invoice_model.invoice_subtotal = this.invoice_subtotal;
                    
                      // this.invoice_model = this.invoiceItem;
                      // // updated by
                      // let update_user = this.sessionUserId;
                      // this.invoice_model.updated_by = this.sessionUserId;  

                      this.app_route_gst = app_route_billing_items.reduce((a, b) => a += Number(b.tax), 0); // now calculates
                      this.model.app_route_gst = this.app_route_gst;
                      this.brandForm.controls['app_route_gst'].setValue(this.app_route_gst);
                      // this.brandForm.app_route_gst.value = this.brandForm.app_route_gst.value;

                       this.app_route_total = this.app_route_billing_items.reduce((a, b) => a += Number(b.total), 0);
                      this.model.app_route_total = this.app_route_total + this.app_route_gst;
                      this.brandForm.controls['app_route_total'].setValue(this.app_route_total);


                      this.app_route_time_estimate = this.app_route_billing_items.reduce((a, b) => a += Number(b.qty), 0);
                      this.model.app_route_time_estimate = this.app_route_time_estimate;
                      this.brandForm.controls['app_route_time_estimate'].setValue(this.app_route_time_estimate);

                      this.app_route_subtotal = (this.app_route_total - this.app_route_gst);
                      this.brandForm.controls['app_route_subtotal'].setValue(this.app_route_subtotal);


                    console.log('Calcuated Fugures: On Load - GST' + this.app_route_id);
    
      }

   getVariableCodeBlock(variable_code_block_id) {
    this._demoService.getVariableCodeBlock(variable_code_block_id).subscribe(
       data => { this.variable_code_block = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getAppRoute(app_route_id) {
    this._demoService.getAppRoute(app_route_id).subscribe(
       data => { this.app_route = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getVariableCodeBlockTypes() {
    this._demoService.getVariableCodeBlockTypes().subscribe(
        data => { this.variable_code_job_types = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }


    getVariableCodeBlockInsertTypes() {
      this._demoService.getVariableCodeBlockInsertTypes().subscribe(
          data => { this.variable_code_block_insert_types = data; },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }
  



      getAppRouteTypes() {
        this._demoService.getAppRouteTypes().subscribe(
            data => { this.app_route_types = data; },
            err => console.error(err),
            // () => console.log('done loading Trace Types')
          );
        }
    
    
        getAppRouteInsertTypes() {
          this._demoService.getAppRouteInsertTypes().subscribe(
              data => { this.app_route_insert_types = data; },
              err => console.error(err),
              // () => console.log('done loading Trace Types')
            );
          }
      


          getAppRoutes() {
            this._demoService.getAppRoutes().subscribe(
               data => { this.app_routes = data;
              
              },
               err => console.error(err),
               () => console.log('System Log Type')
             );
           }


           getAppRoutesWithChildItems() {
            this._demoService.getAppRoutesWithChildren().subscribe(
               data => { this.app_routes_with_children = data;

                console.log('App Routes with Childrem, ', JSON.stringify(this.app_routes_with_children));
              
              },
               err => console.error(err),
               () => console.log('System Log Type')
             );
           }


   
  getJobServiceTimeframe(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    // this.model.job_type_location_id = 1;
   // this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }


  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
       data => { this.job_type_court = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeDocument(job_type_document_type_id) {
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
       data => { this.job_type_document = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobTypeAffidavit(job_type_affidavit_type_id) {
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
       data => { this.job_type_affidavit = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   



   getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   updateJobServiceTimeframe(model) {
    this._demoService.updateJobServiceTimeframe(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Service Timeframe Updated');
       // Subject to reload the manager component parent.
    //  this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Service Timeframe!');
         return console.error(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }


    updateAppRoute(model) {

        this.model.updated_by = this.gfunc.sessionUserId;
        // this.model.created_by = this.gfunc.sessionUserId;

      this.getAppRouteBillingItems(this.app_route_id); // refresh totals of billing items before save important

      this._demoService.updateAppRoute(model).subscribe(
         data => {
         // console.log(model);
           // this.trace_candidate_update = data;
         this.toastr.success('App Route Updated');
         // Subject to reload the manager component parent.
        // this.closeParentModel.emit();
         // CreateJobTypeComponent.returned.next(false);
           return true;
         },
         error => {
           console.error('Error saving App Route!');
           return console.error(error);
         }
        // err => console.error(err),
        // () => console.log('done updates')
      );
      }



    updateVariableCodeBlock(model) {
      this._demoService.updateVariableCodeBlock(model).subscribe(
         data => {
         // console.log(model);
           // this.trace_candidate_update = data;
         this.toastr.success('Code Block Updated');
         // Subject to reload the manager component parent.
      //  this.closeParentModel.emit();
         // CreateJobTypeComponent.returned.next(false);
           return true;
         },
         error => {
           console.error('Error saving Code Block!');
           return console.error(error);
         }
        // err => console.error(err),
        // () => console.log('done updates')
      );
      }


   updateJobTypeAffidavit(model) {
    this._demoService.updateJobTypeAffidavit(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Affidavit Type Updated');
       // Subject to reload the manager component parent.
      //  this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Affidavit!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }
    


    
    getJobTypeCourts(job_type_location_id) {
      this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
         data => { this.job_type_courts = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeCourtsID(job_type_location_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_location_id = job_type_location_id;
      this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
    
    }


    getJobTypeDocumentTypes(job_type_court_id) {
      this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
         data => { this.job_type_document_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeDocumentTypesID(job_type_court_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_court_id = job_type_court_id;
      this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  
    }





    getJobServiceTimeframeCountTypes() {
      this._demoService.getJobServiceTimeframeCountTypes().subscribe(
         data => { this.job_service_timeframe_count_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
  
     getJobServiceTimeframeTimeTypes() {
      this._demoService.getJobServiceTimeframeTimeTypes().subscribe(
         data => { this.job_service_timeframe_time_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
  
  
     getJobServiceTimeframeTimeWhen() {
      this._demoService.getJobServiceTimeframeTimeWhen().subscribe(
         data => { this.job_service_timeframe_time_when = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
  
     getJobServiceTimeframeDateTypes() {
      this._demoService.getJobServiceTimeframeDateTypes().subscribe(
         data => { this.job_service_timeframe_date_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }

     getSystemLogTypeDataSectors() {
      this._demoService.getSystemLogTypeDataSectors().subscribe(
         data => { this.system_log_type_data_sectors = data;
        
        },
         err => console.error(err),
         () => console.log('System Log Type')
       );
     }
    




     getFormUserLevels() {
      this._demoService.getUserLevels().subscribe(
         data2 => { this.user_levels = data2;
          console.log(data2);
       },
         err => console.error(err),
         () => console.log('done loading User Levels')
       );
     }
  
  
     getBrandTypes() {
      this._demoService.getBrandBrandTypes().subscribe(
         data => { this.brand_types = data; },
         err => console.error(err),
         // () => console.log('done loading candidate for update')
       );
     }



     getUsers() {
      this._demoService.getUsers().subscribe(
        data => { this.users = data;
          this.usersPrimary = data;
         let res = data[0];
       },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }
    



     public onChangeSetThisModel(model){
      // this.model = model;
      // console.log('promoID:' + model.promotion_id);
      this.promotion_id = this.brandForm.controls['pps_promotion_id'].value;
        console.log('promoID:' + this.promotion_id);
      // this.brandForm.controls['woo_coupon_id'].patchValue(data.id);
    }
    
    
        public onClickPromotionButton() {
          // this.rteObj.focusIn();
          this.openModalWithComponent_Promotion();
      }
      
      
         // MODAL view a component
         openModalWithComponent_Promotion() {
          const initialState = {
            title: 'Select Promotion Item(s) - Choose for Templates',
            item_id: 1010,
            brand_id: this.brand_id,
            promotion_id: this.promotion_id,
            template_model: this.subject_template_doc,
            size: 'lg',
            backdrop: true,
            IgnoreBackdropClick: false,
          };
          this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
          // sets the var to in the component model
          this.bsModalRef.content.brand_id = this.brand_id;
          this.bsModalRef.content.item_id = this.brand_id;
          this.bsModalRef.content.closeBtnName = 'Close';
          this.bsModalRef.content.brand_model = this.brand;
          this.bsModalRef.content.promotion_id = this.promotion_id;
          this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
          // subscribed to the emitter and get the value.
                    //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                    // // console.log(value); // here you will get the value of the file
                    // // Remove the "uploads/" part from the filename.
                    // this.filenameselected = value;
                    // this.stripped = this.filenameselected.replace('uploads/', '');
                    // // this.model.main_image = this.stripped; // works for simple add not update.
                    // // console.log(this.stripped);
                    // // console.log(this.model);
                    // this.form.logo = this.stripped;
                    // // this.form.reset();
                    // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                    // this.brandForm.controls['logo'].patchValue(this.form.logo);
                    
                    // });
                    // modal component method clickOK to run local method addFileNameFromModal
                    // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
                
                    // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
      
                    this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                    this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                    this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                    this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
                    this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
      
                    
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
      
                    // return this.modalRef.content.onClose;
      
        }
      
      
       // this willl have to be avariable.
            // :: Parent / Child modal test
            public insertPromotionFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                      // auto inserts the variable name of theat which was sent.
                      let insert_tag = 'NOT USED -- {{' + fileurl + '}}'
        
              // this.brandForm.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
        
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
      
      
            public insertStrFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                      // auto inserts the variable name of theat which was sent.
                      let insert_tag = '' + fileurl + ''
        
              // this.brandForm.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
        
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
      
      
            public insertVariableFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                      // auto inserts the variable name of theat which was sent.
                      let insert_tag = '${' + fileurl + '}'
        
              // this.brandForm.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
        
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
    
    
    
    
            public insertImageQRFromModal(fileurl) {
              // alert('Clicked Insert');
        
        
                      // Try wrapping an image tag around the image before inserting.
                      // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
        
                      // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
    
                                      // april 28 2023 - now in assets of brand.
                    let link = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id + '/qrcodes/' + fileurl;
                    let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="'+ link + '" >'
      
                      // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src=" https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
        
              // this.brandForm.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
              this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
              // InsertHtml.Insert(document, document.createTextNode(fileurl));
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              // InsertHtml.Insert(document, document.createElement('image') )
        
        
              // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
        
        
              // insertImage(fileurl);
        
              // has to be correct form name
            // this.modalRef.hide();
            // console.log('Added External Recipeint.');
            // this.toastr.info('External Recipient Added');
            };
      
    
    
    
    
        // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
      // WORKS as I created my own function from this articel == pretty well convers
      transform2(value: any, args?: any): any {
        const doc = new DOMParser().parseFromString(value, 'text/html');
        return doc.documentElement.textContent;
      }










   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Template Document',
      item_id: 1010,
      doc_id: this.doc_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadDocxTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Communication Template Document Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
                //     this.bsModalRef.content.action.take(1).subscribe((value) => {
                //   // console.log(value); // here you will get the value of the file
                //   // Remove the "uploads/" part from the filename.
                //   this.filenameselected = value;
                // // this.stripped = this.filenameselected.replace('uploads/', '');
                //   // this.model.main_image = this.stripped; // works for simple add not update.
                //   // console.log(this.stripped);
                //   // console.log(this.model);
                //   // this.form.logo = this.stripped;
                //   this.form.doc_template_file = this.filenameselected;
                //   // this.form.reset();
                //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                //   this.brandForm.controls['doc_template_file'].patchValue(this.form.doc_template_file);

                //   });

                  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// Angular 14 working.....

   }


		// :: Parent / Child modal test
		public addFileNameFromModal(filename) {
		  alert('Clicked');
		  this.brandForm.controls['doc_template_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};

		// :: Parent / Child modal test
		public insertImageFromModal(fileurl) {
		  // alert('Clicked Insert');


              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'

		  // this.brandForm.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
      this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
      // InsertHtml.Insert(document, document.createTextNode(fileurl));
      InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
      // InsertHtml.Insert(document, document.createElement('image') )


      // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


      // insertImage(fileurl);

      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};


      // MODAL view a component
      openModalDotComponent() {
        const initialState = {
          title: 'Upload Template Document',
          item_id: 1010,
          doc_id: this.doc_id,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(UploadDotTemplateModalComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.doc_id = this.doc_id;
        this.bsModalRef.content.item_id = this.doc_id;
        this.bsModalRef.content.title = 'Original Word Files';
        this.bsModalRef.content.closeBtnName = 'Close';
       // this.bsModalRef.content.brand_model = this.subject_template_doc;
        // subscribed to the emitter and get the value.
              //     this.bsModalRef.content.action.take(1).subscribe((value: any) => {
              //   // console.log(value); // here you will get the value of the file
              //   // Remove the "uploads/" part from the filename.
              //   this.filenameselected = value;
              //  // this.stripped = this.filenameselected.replace('uploads/', '');
              //   // this.model.main_image = this.stripped; // works for simple add not update.
              //   // console.log(this.stripped);
              //   // console.log(this.model);
              //   // this.form.logo = this.stripped;
              //  // this.form.doc_template_file = this.filenameselected;
              //   this.form.original_doc_file = this.filenameselected;
              //   // this.form.reset();
              //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              //   this.brandForm.controls['original_doc_file'].patchValue(this.form.original_doc_file);

              //   });

              this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ODF.bind(this)); /// Angular 14 working.....

       }


		// :: Parent / Child modal test
		public addFileNameFromModal_ODF(filename) {
		  // alert('Clicked');
		  this.brandForm.controls['original_doc_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};

       

   // MODAL view a component
   openModalEmailTemplates() {
    const initialState = {
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadEmailTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Email Template Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
        //     this.bsModalRef.content.action.take(1).subscribe((value) => {
        //   // console.log(value); // here you will get the value of the file
        //   // Remove the "uploads/" part from the filename.
        //   this.filenameselected = value;
        //  // this.stripped = this.filenameselected.replace('uploads/', '');
        //   // this.model.main_image = this.stripped; // works for simple add not update.
        //   // console.log(this.stripped);
        //   // console.log(this.model);
        //   // this.form.logo = this.stripped;
        //   this.form.email_template = this.filenameselected;
        //   // this.form.reset();
        //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
        //   this.brandForm.controls['email_template'].patchValue(this.form.email_template);

        //   });
        this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ET.bind(this)); /// Angular 14 working.....
   }





   // MODAL view a component
   openModalWithComponent_Brand() {
    const initialState = {
      title: 'Upload Image / Photo',
      item_id: 1010,
      brand_id: this.brand_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(FileUploadsModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.brand_id;
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.brandForm.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name

              this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }



		// :: Parent / Child modal test
		public addFileNameFromModal_ET(filename) {
		  // alert('Clicked');
		  this.brandForm.controls['email_template'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};


    public onClickImageButton() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_Brand();
  }
  
    // public onCreate(): void { 
    //   let data: { [key: string]: Object }[] = [
    //       { Id: '2', Name: 'FirstName' },
    //       { Id: '2', Name: 'LastName' },
    //       { Id: '3', Name: 'MiddleName' }
    //   ];
    //   let proxy = this.rteObj;
    //    let dropdownVariables: DropDownList = new DropDownList({
    //       dataSource: data,
    //       fields: { text: 'Name' },
    //       placeholder: 'Insert Fields',
    //       width: '100px',
    //       change: (args: any)=>{
    //         proxy.focusIn();
    //         InsertHtml.Insert(document, document.createTextNode(args.value));
    //       }
    //   });
    //   dropdownVariables.appendTo('#dropdownVariables');
      
      
    //   } 
  
    //   public onCreate2(): void { 
    //     this.proxy = this.defaultRTE;
    //     // initialize Custom DropDownList component
    //      this.dropdownVariables = new DropDownList({
    //       dataSource: this.dataVariables,
    //       fields: { text: 'Name', value: 'insertValue' },
    //       // fields: { text: 'Name' },
    //       placeholder: 'My Details',
    //       width: '300px',
    //       change: (args: any)=>{
    //         this.defaultRTE.focusIn();
    //         InsertHtml.Insert(document, document.createTextNode(args.value));
    //       }
    //     });
    //     this.dropdownVariables.appendTo('#dropdownVariables');
  
  
    //     this.dropdownVariablesOrder = new DropDownList({
    //       dataSource: this.dataVariablesOrder,
    //       fields: { text: 'Name', value: 'insertValue' },
    //       // fields: { text: 'Name' },
    //       placeholder: 'Order Variables',
    //       width: '300px',
    //       change: (args: any)=>{
    //         this.defaultRTE.focusIn();
    //         InsertHtml.Insert(document, document.createTextNode(args.value));
    //       }
    //     });
    //     this.dropdownVariablesOrder.appendTo('#dropdownVariablesOrder');
  
    //     this.dropdownVariablesOrderSender = new DropDownList({
    //       dataSource: this.dataVariablesOrderSender,
    //       fields: { text: 'Name', value: 'insertValue' },
    //       // fields: { text: 'Name' },
    //       placeholder: 'Order Sender',
    //       width: '300px',
    //       change: (args: any)=>{
    //         this.defaultRTE.focusIn();
    //         InsertHtml.Insert(document, document.createTextNode(args.value));
    //       }
    //     });
    //     this.dropdownVariablesOrderSender.appendTo('#dropdownVariablesOrderSender');
  
  
    //     this.dropdownVariablesOrderPickList = new DropDownList({
    //       dataSource: this.dataVariablesOrderPickList,
    //       fields: { text: 'Name', value: 'insertValue' },
    //       // fields: { text: 'Name' },
    //       placeholder: 'Pick List Items',
    //       width: '300px',
    //       change: (args: any)=>{
    //         this.defaultRTE.focusIn();
    //         InsertHtml.Insert(document, document.createTextNode(args.value));
    //       }
    //     });
    //     this.dropdownVariablesOrderPickList.appendTo('#dropdownVariablesOrderPickList');
  
  
  
  
    //   }
  
  
    //     // drop down function
    //     onChangeVariables(args): void {
    //     //  let element: HTMLElement = document.createElement('p');
    //     if (args.isInteracted) {
    //     //  element.innerText = 'Changes happened by Interaction';
    //     // this.container.documentEditor.editor.insertText(args.value); // works for workd editor
    //     this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    //     InsertHtml.Insert(document, document.createTextNode(args.value));
    //     this.toastr.info('Variable Added at cursor position within Template');
    //     // hide the modal
    //    // this.modalRef.hide();
    //     } else {
    //     // element.innerText = 'Changes happened by programmatic';
    //     }
  
    //     // document.getElementById('event').append(element);
    //     };
  
  
  
  
  
  
  
  
    // oncreated() {
    //   this.proxy = this;  
    //   // initialize Custom DropDownList component
    //    this.dropDownListObject = new DropDownList({
    //       placeholder: "Select PlaceHolder Value",
    //       width: "180px",
    //       fields: { text: 'StateName', value: "SateId" },
    //       // change: (args: any)=>{
    //       //   this.defaultRTE.focusIn();
    //       //   InsertHtml.Insert(document, document.createTextNode(args.value));
    //       // }
    //       change: this.OnChanged.bind(this),
    //       //set the data to dataSource property
    //       dataSource: this.placeHolderdata
    //   });
    //   this.dropDownListObject.appendTo('#ddlelement');
    // }
    // //Parent dropdown change event
  
    //     //pass the filter data source, filter query to updateData method.
    // public countryChange(): void {
    //   let predicate = new Predicate('CountryId', 'equal', this.countryObj.value, true);
    //   predicate = predicate.or('CountryId', 'equal','0' ,true);
    //   let query: Query = new Query();
    //     //frame the query based on search string with filter type.
    //     query = query.where(predicate);
    //   // let tempQuery: Query = new Query().where('CountryId', 'equal', this.countryObj.value); // commented out in example
    //   //     this.dropDownListObject.query = tempQuery;
    //       this.dropDownListObject.query = query;
    //         this.dropDownListObject.text = null;
    //           this.dropDownListObject.dataBind();
    //           this.isParentDropdownChanged = true;
              
    // }
    // OnChanged(args) { 
    //   //Change the Rich Text Editor placeholder
    //   // this.defaultRTE.placeholder = args.value;
    //   this.defaultRTE.focusIn();
    //   InsertHtml.Insert(document, document.createTextNode(args.value));
  
    // }
    // clicked() {
    //   this.defaultDialog.show();
    // }
  
  

// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
      // small upgrade to disable background click on open modal background
      const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
      this.modalRef = this.modalService.show(template, config);
}

// // :: Parent / Child modal test
// closeParentModel() {
//   // alert('parent component function.');
//   this.modalRef.hide();
//  // this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// };




setColour(value2){
  console.log('SetColour: ' + value2)
  // this.brandForm.app_route_colour.value = this.brandForm.colourpicker.value
}



makeDuplicateAppRoute(model){
  if (confirm('We are about duplicate this item, Are you Sure?')) {
  // post a new With this model. & Name as copuy
  model.app_route_name =  model.app_route_name + '_COPY'
  if (model.app_route_description != null){model.app_route_description = '_COPY **** of **** ' + model.app_route_description}
  if (model.app_route_notes != null){model.app_route_notes = '_COPY **** of **** ' + model.app_route_notes}
  if (model.app_route_as_actual_NAME != null){model.app_route_as_actual_NAME = model.app_route_as_actual_NAME + '_COPY'}
  if (model.app_route_as_variable != null){ model.app_route_as_variable = model.app_route_as_variable + '_COPY'}
  if (model.app_route_as_variable_NAME != null){model.app_route_as_variable_NAME = model.app_route_as_variable_NAME + '_COPY'}
  if (model.routerLink != null){model.routerLink = '_COPY **** of **** ' + model.routerLink}
  if (model.routerLinkGeneral != null){model.routerLinkGeneral = '_COPY **** of **** ' + model.routerLinkGeneral}
  if (model.help_content != null){model.help_content = '_COPY **** of **** ' + model.help_content}
  if (model.help_content_HTML != null){model.help_content_HTML = '_COPY **** of **** ' + model.help_content_HTML}
  if (model.video_content != null){model.video_content = '_COPY **** of **** ' + model.video_content}
  if (model.guided_tour_content != null){model.guided_tour_content = '_COPY **** of **** ' + model.guided_tour_content}

  // model.is_active = '';
  this.createAppRoute(model);

  }
}
createAppRoute(model) {
  // console.log(model);
    this._demoService.createAppRoute(model).subscribe(
          data => {  this.get_latest_app_route_id = data; // this is the retuned json upon creation.

          this.toastr.success('App Route Added!');
           
  /*
          // tslint:disable-next-line:max-line-length
          this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
          this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
  */
          // this.closeParentModel.emit();
        //   CreateJobTypeComponent.returned.next(false);
            //  return true;
          },
          error => {
            this.toastr.error('Adding App Route Failed :: Please try again!');
            // console.log(Observable.throw(error));
            // return Observable.throw(error);
          console.error(error);
          }
    );
    }


    getProjects() {
      this._demoService.getProjects().subscribe(
        data => {
          this.projects = data;
          let res = data[0]
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.projects_data = DataUtil.parse.parseJson(data);
  
  // :: TO A loop of details below.

  

  
        },
        error => {
          //  console.error('Error Loading User!');
          // return Observable.throw(error);
        }
      );
    }
  



  //     // :: Parent / Child modal test
  // closeParentModel() {
  //   // alert('parent component function.');
  //   this.modalRef.hide();
  //  // this.refreshGrid(); // resets the grid if updated and closed.
  // //  this.updateTypeClick = false; // closes the div
  // };
  



  showLoadKanPanChildren(){
    this.search_model = {
      app_route_parent_id: this.app_route_id,
    }// set to empty to get all first.
    this.getAppRoutesSearchFull(this.search_model);
  }
  

  showLoadKanPanRouterLink(model){
    this.search_model = {
      routerLink: model.routerLink,
    }// set to empty to get all first.
    this.getAppRoutesSearchFull(this.search_model);
  }
  


  getAppRoutesSearchFull(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_full_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data = this.app_routes_metrix_search_full_results.slice(0, 500);
        // this.app_route = this.new_data; // sets the data
  
        this.new_children_data = this.app_routes_metrix_search_full_results.slice(0, 500);
      

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );
         
  
  }



// greater
  showLoadRouteDiagramChildren(model){
    this.search_model = {
      file_number: model.file_number,
      file_number_selector: 'greater',
      project_id: model.project_id
    }// set to empty to get all first.
    this.getAppRoutesSearchFull(this.search_model);
  }


// to ge the children we have to get the childre of the parent route _id... of the current Route. 
// and number greater.....

  // showLoadRouteDiagramChildren(model){
  //   this.search_model = {
  //     file_number: model.file_number,
  //     file_number_selector: 'greater',
  //     // project_id: model.project_id
  //   }// set to empty to get all first.
  //   this.getAppRoutesSearchFull(this.search_model);
  // }
  
  showLoadRouteDiagramParents(model){
    this.search_model = {
      file_number: model.file_number,
      file_number_selector: 'less',
      project_id: model.project_id
    }// set to empty to get all first.
    this.getAppRoutesSearchFull(this.search_model);
  }
  
  

}
